import { z } from 'zod';
/** Narrow Projects-owned identity verification capability for import consumers. */
export const projectsImportResolutionCapability = 'projects.import-resolution.v1';
const timestamp = z.string().datetime({ offset: true });
const uuid = z.string().uuid();
const sha256 = z.string().regex(/^[a-f0-9]{64}$/);
/** Durable proof that one imported Project identity is tenant-bound and target-backed. */
export const projectsImportResolutionSchema = z.strictObject({
    capability: z.literal(projectsImportResolutionCapability),
    entityType: z.literal('project'),
    sourceId: z.string().trim().min(1).max(500),
    targetId: uuid,
    sourceSha256: sha256,
    sourceUpdatedAt: timestamp,
    runId: uuid,
    targetSha256: sha256,
});
//# sourceMappingURL=projects-import-resolution.contract.js.map